<template>
 <div class="o-reward-single">

    <app-navigation :currentSpace="$t('web.rewards_single.nav_space')" backButton="true"></app-navigation>

    <main class="o-reward-single__main">

      <search-bar></search-bar>

      <catalog-reward-detail></catalog-reward-detail>

    </main>

    <app-footer></app-footer>

  </div>
</template>

<script>
import Reward from '@/views/components/catalog/Reward'
import SearchBar from '@/views/components/catalog/SearchBar'
import { mapGetters } from 'vuex'

export default {
  name: 'RewardsSingle',
  components: {
    'catalog-reward-detail': Reward,
    'search-bar': SearchBar
  },
  mounted () {
    this.$store.dispatch('GET_REWARD', this.$route.params.id).then(() => {
      if (this.rewardDetails.supplier_items[0].availability_status.toLowerCase() !== 'available') {
        this.$router.push({ name: 'RewardUnavailable' })
      }
    }).catch(() => {
      this.$router.push({ name: 'RewardUnavailable' })
    })
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(error => Promise.reject(error))
  },
  computed: {
    ...mapGetters([
      'rewards',
      'rewardDetails'
    ])
  }
}

</script>

<style lang="css" scoped>
.o-reward-single__main {
  z-index: 101 !important;
}
</style>



// WEBPACK FOOTER //
// RewardsSingle.vue?2d111ba4